import React from 'react'
import { Widget } from '@typeform/embed-react'
import { split } from 'lodash'

export const isTypeform = (link: string) => {
    return link.indexOf('form.typeform') >= 0
}

export interface TypeformProps {
    link: string
    width?: number
    height?: number
}

function getFormId(link: string) {
    //example form link: https://form.typeform.com/to/m2P4fIIp
    const parts = split(link, '/')
    return parts[parts.length - 1]
}

export const Typeform: React.FC<TypeformProps> = (props) => {
    const id = getFormId(props.link)
    return (
        <Widget
            id={id}
            autoResize={true}
            disableScroll={true} //this refers to scrolling between questions, not the scrollbar
            lazy={true}
            noHeading={true}
        />
    )
}
